import { css } from 'styled-components';

export const iconBtnCss = css`
  & span {
    font-size: 1.1rem;
  }
`;
